export default __webpack_public_path__ + "static/media/Deep waters1.51944557.jpg";